import { PortfolioSourcesService_portfolioSourcesServiceGetPortfoliosLatest } from '@festina/unitlink-general-types/unitlink/hooks/PortfolioSourcesService_portfolioSourcesServiceGetPortfoliosLatest'

export const useFetchPortfolioLatestForUseInEditPortfolio =
  // Intended for use in the raw EditPortfolioCommandData; other components should use the Version
  PortfolioSourcesService_portfolioSourcesServiceGetPortfoliosLatest.useSuspenseQuery
